(function( PLUGINS ) {

	"use strict";

	var $$compileProvider;

	var registeredPlugins = {};

	var app;

	angular.module("gameApp")


	.config([ "$provide", "$compileProvider", "$injector", function( $provide, $compileProvider, $injector ) {
		$$compileProvider = $compileProvider;
	}])


	.run([ "$rootScope", "$injector", "pluginsService", function( $rootScope, $injector, pluginsService ) {


		app = function FakePluginApp( pluginName ) {

			function prependPluginEntityName( name ) {
				return pluginName + name[0].toUpperCase() + name.substr(1);
			}

			return {

				component: function FakePluginAppComponent( componentName, options ) {
					return $$compileProvider.component( prependPluginEntityName( componentName ), options );
				},

				invoke: function( array ) {
					return $injector.invoke( array );
				}

			}
		};


		setTimeout(function() {
			pluginsService.load( "backgroundAudio" );
			pluginsService.load( "fullScreenControlButton" );
		});

	}])


	.service("pluginsService",
				  new Array("$rootScope","$q","$injector", PluginsService ));
	function PluginsService( $rootScope,  $q,  $injector ) {

		this.registeredPlugins = registeredPlugins;

		this.load = function( pluginName, pluginBuilderFn ) {
			
			if (registeredPlugins[ pluginName ]) return $q.reject( "Plugin already registered!" );

			if (!pluginBuilderFn) pluginBuilderFn = PLUGINS[ pluginName ];

			return $q.when( pluginBuilderFn ).then(function( fn ) {

				if (fn) return fn;

				return jQuery.ajax({
					url:"js/plugins/" + pluginName + "/plugin.js",
					cache: true
				}).then(function( script ) {

					script = "((function() { return " + script + "; })())();";

					return (0,eval)( script );

				});

			}).then(function( fn ) {

				return load( fn, app( pluginName ) );

			});
		};

		function load( plugin, app ) {
			return $q.when( plugin( app ) );
		}
	}
})({});
